import { RelatedTagsRequest, SearchAdapter } from '@empathy/search-adapter';
import { RelatedTag } from '@empathy/search-types';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { catchAdapterError } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { SetNextQueriesStatePayload } from '../mutations/set-query-signals.mutation';
import { QUERY_SIGNALS_ACTIONS_KEYS, QUERY_SIGNALS_GETTERS_KEYS } from '../query-signals.const';
import { QuerySignalsAction, QuerySignalsContext } from '../query-signals.interfaces';

export class GetQuerySignalsAction implements QuerySignalsAction {

  protected searchAdapter: SearchAdapter;

  actions = {
    [QUERY_SIGNALS_ACTIONS_KEYS.getNextQueries]: ({ rootGetters }: QuerySignalsContext,
      query: string): Promise<SetNextQueriesStatePayload> =>
      this.platformAdapter.getNextQueries(this.getQuerySignalRequest(query, rootGetters))
        .then(response => ({ nextQueries: response.nextQueries, nextQueriesQuery: query })),

    [QUERY_SIGNALS_ACTIONS_KEYS.getRelatedTags]: ({ rootState, rootGetters, getters }: QuerySignalsContext): Promise<RelatedTag[]> =>
      this.platformAdapter.getRelatedTags(this.getQuerySignalRequest(rootState.core.inputQuery, rootGetters))
        .then(({ relatedTags }) => (getters[QUERY_SIGNALS_GETTERS_KEYS.selectedRelatedTags] as RelatedTag[]).concat(relatedTags))
  };

  private get platformAdapter(): SearchAdapter {
    return this.searchAdapter = this.searchAdapter ?? container.get<SearchAdapter>(DEPENDENCIES.Adapter);
  }

  private getQuerySignalRequest(query: string, rootGetters: any): RelatedTagsRequest {
    return {
      query,
      relatedTags: rootGetters[GETTERS_KEYS.querySignals.selectedRelatedTags]
    };
  }
}
